import axios from "axios";
import { useEffect, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { Form, Button } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { getInventoryConsumption } from "../../../redux/inventory";
import { FiPlus } from "react-icons/fi";
import PaginatedList from "./PaginatedList";
import { formatDate } from "../../utils/dateFormatter";
import { useNavigate } from "react-router-dom";
// backend rows not saved 

const Consumption = ({ args }) => {
  const auth = useSelector((state) => state.authentication);
  const dispatch = useDispatch();
  const { userData } = auth;
  const itemsList = useSelector((state) => state.inventory);
  const { itemsData, consumptionData } = itemsList;
  const [searchInput, setSearchInput] = useState("");
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [paginatedList, setPaginatedList] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [refreshToggle, setRefreshToggle] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [loading, setLoading] = useState(false); 
  const API_BASE = `${process.env.REACT_APP_COLLEGE_ERP_API}`;
  const [employees, setEmployees] = useState([]);
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [staffId, setStaffId] = useState("");
const [department, setDepartment] = useState("");
const [globalDate, setGlobalDate] = useState("");
 const [formData, setFormData] = useState([
  {
    _id: `${Date.now()}_${Math.random()}`,
    item: "",
    productId: "",
    batch: "",
    mrp: "",
    quantity: "",
    stockQty: "",
    unit: "No",
    remarks: "",
    createdBy: userData.user,
  },
]);
  
  console.log("itemsData", itemsData);
const [filters, setFilters] = useState({
  fromDate: "",
  toDate: "",
  item: "",
});

const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const applyFilters = () => {
  setRefreshToggle((prev) => !prev); // trigger API refresh
};

useEffect(() => {
  const fetchDepartments = async () => {
    try {
      const response = await axios.get(`${API_BASE}employee-dpts`, {
        params: { branch: userData.branch },
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      });

      setDepartments(response.data?.data || response.data || []);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  fetchDepartments();
}, []);

const fetchEmployees = async (filters = {}) => {
  setLoading(true);

  try {
    const cleanParams = Object.fromEntries(
      Object.entries({
        branch: userData.branch,
        search: filters.search,
        employeeId: filters.employeeId,
        designation: filters.designation,
        department: filters.department,
        employment: filters.employment,
        gender: filters.gender,
        fromJoiningDate: filters.fromJoiningDate,
        toJoiningDate: filters.toJoiningDate,
        fromDOB: filters.fromDOB,
        toDOB: filters.toDOB,
        page: filters.page || 1,
        limit: filters.limit || 10,
      }).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
    );

    const response = await axios.get(`${API_BASE}employee`, {
      params: cleanParams,
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    });

    const result = response;

    setEmployees(result.data || result || []);
   // setTotalPages(result.totalPages || 1);

  } catch (error) {
    console.error("Error fetching employees:", error);

    if (
      error?.response?.data?.err?.name === "JsonWebTokenError" ||
      error?.response?.data?.message === "Unauthorized"
    ) {
      localStorage.removeItem("token");
      navigate("/");
      return;
    }

    alert("Failed to fetch employees.");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    dispatch(
      getInventoryConsumption({
        token: userData.token,
        branch: userData.branch,
      })
    );
  }, [dispatch, userData.token, userData.branch]);
 
   const handleSubmit = async () => {
  const isValid = isFormDataValid();

  if (!isValid) return;

  setShowSpinner(true);

  try {
    // ✅ Prepare rows for backend
    const rows = formData.map((data) => ({
      productId: data.productId,
      batch: data.batch, // ⚠️ MUST ensure batch is captured in UI
      item: data.item,
      quantity: Number(data.quantity),
      mrp: data.mrp || 0,
      expiry: data.expiry || null,
    }));

    // ✅ Call unified inventory API
    const response = await axios.post(
      `${process.env.REACT_APP_COLLEGE_ERP_API}process-inventory`,
      {
        branch: userData.branch,
        type: "sale", // 🔥 consumption = stock OUT
        reference: "CONSUMPTION",
        user: userData.user,
        rows,
      },
      {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      }
    );

    if (response.data?.success) {
      alert("Consumption recorded successfully");

      // ✅ Optional: Save consumption details (for reporting)
      await saveConsumptionDetails();

      // ✅ Refresh
      dispatch(
        getInventoryConsumption({
          token: userData.token,
          branch: userData.branch,
        })
      );

      resetFormData();
      toggle();
    }

  } catch (error) {
    console.error("Consumption Error:", error);
    alert(error.response?.data?.message || "Consumption failed");
  } finally {
    setShowSpinner(false);
  }
};

  

  // Reset form data after successful submission
  const resetFormData = () => {
    setFormData(
      formData.map(() => ({
        item: "",
        productId: "",
        batch: "",
        quantity: "",
        stockQty: "",
        unit: "",
       
        
        remarks: "",
      
        
      }))
    );
  };
const handleChange = async (e, colName, index) => {
  const { name, value } = e.target;

  // ✅ If department changes → fetch employees
  if (name === "department") {
    try {
      setLoading(true);

      const response = await axios.get(`${API_BASE}employee`, {
        params: {
          branch: userData.branch,
          department: value,
        },
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      });

      setEmployees(response.data || []);

   
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoading(false);
    }

    return;
  }

  // existing logic 👇
  if (name === "quantity") {
    if (
      formData[index].stockQty &&
      Number(value) > Number(formData[index].stockQty)
    ) {
      alert("Quantity exceeds available stock");
    }
  }

  if (colName === "item") {
    const selectedOption = e.target.list.querySelector(
      `option[value="${value}"]`
    );

    const cost = selectedOption?.getAttribute("data-cost");
    const productId = selectedOption?.getAttribute("data-productid");
    const product = selectedOption?.getAttribute("data-product");
    const stockQty = selectedOption?.getAttribute("data-qty");
    const batch = selectedOption?.getAttribute("data-batch");

    setFormData((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        item: product,
        rate: cost,
        productId,
        batch,
        stockQty,
      };
      return updated;
    });

    return;
  }

  // default update
  setFormData((prev) => {
    const updated = [...prev];
    updated[index] = { ...updated[index], [name]: value };
    return updated;
  });
};
const isDuplicate = (rows) => {
  const seen = new Set();

  for (let r of rows) {
    const key = `${r.productId}_${r.batch}`;
    if (seen.has(key)) return true;
    seen.add(key);
  }
  return false;
};

   const isFormDataValid = () => {
  let errors = [];

  // ✅ Global validations
  if (!formData.length) {
    errors.push("Add at least one item");
  }

  if (!staffId) {
    errors.push("Staff is required");
  }

  if (!department) {
    errors.push("Department is required");
  }

  if (!globalDate) {
    errors.push("Date is required");
  }

  // ✅ Duplicate check
  if (isDuplicate(formData)) {
    errors.push("Duplicate item with same batch not allowed");
  }

  // ✅ Row validations
  formData.forEach((data, index) => {
    const row = index + 1;
    const quantity = Number(data.quantity);
    const stockQty = Number(data.stockQty);

    // 🔹 Item
    if (!data.item || data.item.trim() === "") {
      errors.push(`Row ${row}: Item is required`);
    }

    // 🔹 ProductId (important)
    if (!data.productId) {
      errors.push(`Row ${row}: Invalid item selection`);
    }

    // 🔹 Batch (VERY IMPORTANT)
    if (!data.batch) {
      errors.push(`Row ${row}: Batch is required`);
    }

    // 🔹 Quantity
    if (!data.quantity || data.quantity.toString().trim() === "") {
      errors.push(`Row ${row}: Quantity is required`);
    } else if (isNaN(quantity) || quantity <= 0) {
      errors.push(`Row ${row}: Quantity must be greater than 0`);
    } else if (stockQty && quantity > stockQty) {
      errors.push(`Row ${row}: Quantity exceeds available stock`);
    }

    // 🔹 Unit
    if (!data.unit) {
      errors.push(`Row ${row}: Unit is required`);
    }

    
  });

  // ✅ Final check
  if (errors.length > 0) {
    alert(errors.join("\n"));
    return false;
  }

  return true;
};

  const saveConsumptionDetails = async () => {
    //   staffId,
 //   department,
   // date,
    //createdBy,
   // rows,
  const payload = {
    staffId,
    department,
    date: globalDate,
    createdBy: userData.user,
    rows: formData.map((r) => ({
      _id: r._id,
      item: r.item,
      productId: r.productId,
      batch: r.batch,
      expiry: r.expiry,
      mrp: r.mrp,
      quantity: Number(r.quantity),
      unit: r.unit,
      location: r.location,
      remarks: r.remarks,
      status: r.status,
    })),
  };

  await axios.post(
    `${process.env.REACT_APP_COLLEGE_ERP_API}add-consumption`,
    payload,
    {
      params: { branch: userData.branch },
      headers: {
        Authorization: `Bearer ${userData.token}`,
      },
    }
  );
};

  const addRow = () => {
  setFormData((prev) => [
    ...prev,
    {
      _id: `${Date.now()}_${Math.random()}`, // ✅ safer unique id
      item: "",
      productId: "",
      batch: "",
      mrp: "",
      quantity: "",
      stockQty: "",
      unit: "No", // ✅ default (optional)
      remarks: "", // ✅ default (optional)
      createdBy: userData.user,
    },
  ]);
};
  const removeRow = (index) => {
    setFormData((prevFormData) => {
      if (prevFormData.length > 1) {
        return prevFormData.filter((_, i) => i !== index); // Remove the row at the given index
      }
      return prevFormData; // Don't allow removal if it's the last row
    });
  };

  // inside your Consumption component

const flattenedList = paginatedList && paginatedList?.flatMap((doc) => {
  if (doc.rows) {
    return doc.rows.map((row) => ({
      ...row,
      staffId: doc.staffId,
      department: doc.department,
      date: doc.date,
      createdAt: doc.createdAt,
    }));
  }

  // fallback for old data
  return [doc];
}) || [];

  return (
    <Container>
      <Row>
        <Col>
          <Card className="mb-5 mt-2">
            <CardHeader>
              <Row className="d-flex justify-content-center">
                <Col md={4}>
                  <Input
                    type="text"
                    //  id="MRN"
                    list="mrnlist"
                    name="mrn"
                    placeholder="Search record"
                    // value={formData.mrn}
                    onChange={(e) => {
                      setSearchInput(e.target.value);
                    }}
                    //    onBlur={searchMRNHandler}
                    style={{ display: "inline-block", width: "150px" }}
                  />
                  <datalist id="mrnlist"></datalist>
                  <span className="ps-3"></span>
                </Col>
                <Col md={4} style={{ textAlign: "center" }}>
                  <h4>Consumption Record</h4>
                </Col>
                <Col md={4} className="d-flex ">
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      toggle();
                    }}
                  >
                    <FiPlus color="green" /> Add
                  </div>
                  <div
                    style={{ cursor: "pointer" }}
                    className="ms-4"
                    onClick={() => {}}
                  ></div>
                </Col>
              </Row>
              <Row>
                <Row className="mb-3">
  <Col md={3}>
    <Form.Group>
      <Form.Label>From Date</Form.Label>
      <Form.Control
        type="date"
        name="fromDate"
        value={filters.fromDate}
        onChange={handleFilterChange}
      />
    </Form.Group>
  </Col>

  <Col md={3}>
    <Form.Group>
      <Form.Label>To Date</Form.Label>
      <Form.Control
        type="date"
        name="toDate"
        value={filters.toDate}
        onChange={handleFilterChange}
      />
    </Form.Group>
  </Col>
{
 // <Col md={4}>
 //   <Form.Group>
 //     <Form.Label>Item Search</Form.Label>
 //     <Form.Control
 //       type="text"
 //       placeholder="Search item..."
 //       name="item"
 //       value={filters.item}
 //       onChange={handleFilterChange}
 //     />
 //   </Form.Group>
//
 // </Col>
}

  <Col md={2} className="d-flex align-items-end">
    <Button variant="primary" onClick={applyFilters} className="w-100">
      Apply
    </Button>
  </Col>
</Row>
              </Row>
            </CardHeader>
            <CardBody>
              {
          //   <PaginatedList
          //     setPaginatedList={setPaginatedList}
          //        searchInput={searchInput}
          //     setShowSpinner={setShowSpinner}
          //     endPoint="consumption-page"
          //     //  endPoint2="purchase-page"
          //     limit={300}
          //     setPurchasePaginatedList={null}
          //     purchaseLimit={50}
          //     refresh={refreshToggle}
          //   />
          }
              <PaginatedList
  setPaginatedList={setPaginatedList}
  searchInput={searchInput}
  setShowSpinner={setShowSpinner}
  endPoint="consumption-page"
  limit={300}
  setPurchasePaginatedList={null}
  purchaseLimit={50}
  refresh={refreshToggle}
  filters={filters}   // ✅ pass filters
/>


              <Table>
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Unit</th>
                    <th>Remarks</th>
                    <th>Issed Date</th>
                    <th>Created</th>
                    
                    
                  </tr>
                </thead>
                <tbody>
                  {flattenedList.length === 0 && showSpinner && (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <Spinner color="primary">
                          <span></span>
                        </Spinner>
                      </td>
                    </tr>
                  )}
                  {flattenedList.length > 0 &&
                    flattenedList
                      .filter(
                        (item) =>
                          !searchInput ||
                          item.item
                            .toLowerCase()
                            .includes(searchInput.toLowerCase()) ||
                          item.remarks
                            .toLowerCase()
                            .includes(searchInput.toLowerCase())
                      )
                      .map((item, index) => (
                        <tr key={index}>
                          <td>{item.item}</td>
                          <td>{item.quantity}</td>
                          <td>{item?.unit}</td>
                         
        
                          <td>{item.remarks}</td>
                          <td>{formatDate(item.date)}</td>
                          <td>{formatDate(item.createdAt)}</td>
                          
                          
                        </tr>
                      ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        isOpen={modal}
        toggle={toggle}
        {...args}
        style={{ maxWidth: "800px", margin: "0 auto" }}
      >
        <ModalHeader toggle={toggle}>Add Item
      <Row className="mb-3">
  <Col md={4}>
    <Label>Department</Label>
    <Input
      type="select"
      value={department}
      onChange={(e) => {
        const dept = e.target.value;
        setDepartment(dept);
        fetchEmployees({ department: dept });
      }}
    >
      <option value="">Select Department</option>
      {departments.map((dept, i) => (
        <option key={i} value={dept}>
          {dept}
        </option>
      ))}
    </Input>
  </Col>

  <Col md={4}>
    <Label>Staff</Label>
    <Input
      type="select"
      value={staffId}
      onChange={(e) => setStaffId(e.target.value)}
    >
      <option value="">Select Staff</option>
      {employees.map((emp) => (
        <option key={emp._id} value={emp.EmployeeId}>
          {emp.EmployeeId} - {emp.Full_Name}
        </option>
      ))}
    </Input>
  </Col>

  <Col md={4}>
    <Label>Date</Label>
    <Input
      type="date"
      value={globalDate}
      onChange={(e) => setGlobalDate(e.target.value)}
    />
  </Col>
</Row>

        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <Card className="mb-5">
                <CardBody>
                  {itemsData &&
                    formData.map((formData, index) => (
                      <div key={index}>
                        <Row>
                          <Col md={3}>
                            <Label for={`item-${index}`}>Item</Label>
                            <Input
                              type="text"
                              list="itemdata"
                              id={`item-${index}`}
                              name="item"
                              value={formData.item}
                              onChange={(e) => handleChange(e, "item", index)}
                            />
                            <datalist id="itemdata">
                              {itemsData.length &&
                                itemsData.map((item, id) => (
                                  <option
                                    key={id}
                                    value={`${item.item} (${item.quantity})`} // replaced item.productId
                                    data-product={item.item}
                                    data-cost={item.mrp}
                                    data-productid={item.productId}
                                    data-qty={item.quantity}
                                      data-batch={item.batch}
                                  />
                                ))}
                            </datalist>
                          </Col>
                          <Col md={3}>
                            <Label for={`quantity-${index}`}>Quantity</Label>
                            <Input
                              type="number"
                              name="quantity"
                              id={`quantity-${index}`}
                              value={formData.quantity}
                              onWheel={(e) => e.target.blur()}
                              onChange={(e) => handleChange(e, null, index)}
                              placeholder="Enter quantity"
                            />
                          </Col>
                          <Col md={3}>
                            <Label for={`unit-${index}`}>Unit</Label>

                            <select
                              value={formData.unit}
                              name="unit"
                              onChange={(e) => handleChange(e, null, index)}
                              id={`unit-${index}`}
                              className="custom-select-style"
                            >
                              <option value="">Select Unit</option>
                              <option value="Kg">Kg</option>
                              <option value="g">g</option>
                              <option value="L">L</option>
                              <option value="mL">mL</option>
                              <option value="PC">PC</option>
                              <option value="No">No</option>
                              <option value="Tray">Tray</option>
                              <option value="Bag">Bag</option>
                              <option value="Pkt">Pkt</option>
                              <option value="Cylnd">Cylnd</option>
                              <option value="LTRS">LTRS</option>
                            </select>
                          </Col>
                          
                        </Row>
                        <Row>
                         
                        
                        </Row>
                        <Row>
                          <Col md={6}>
                            <Label for={`remarks-${index}`}>Remarks</Label>
                            <Input
                              type="textarea"
                              name="remarks"
                              id={`remarks-${index}`}
                              value={formData.remarks}
                              onChange={(e) => handleChange(e, null, index)}
                              placeholder="Enter remarks"
                            />
                          </Col>
                          
                        </Row>
                        <Row>
                          
                          <Col md={3} className="d-flex align-items-center">
                            <button type="button" onClick={addRow}>
                              +
                            </button>
                            <button
                              type="button"
                              onClick={() => removeRow(index)}
                            >
                              -
                            </button>
                          </Col>
                        </Row>
                        <hr />
                      </div>
                    ))}
                  <Row className="justify-content-end pt-3">
                    <Col md={2} style={{ textAlign: "right" }}>
                      <Button color="primary" onClick={handleSubmit}>
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default Consumption;
